/**
 * Route container for the Moderation page: binds the moderation-action
 * mutation (the pre-existing /admin/moderation/{itemId}/action endpoint)
 * into the presentation component's callback props.
 */

import { useModerationAction, useResolveUserReports } from '../hooks/useAdminOps';
import Moderation from './Moderation';

export default function ModerationContainer() {
  const action = useModerationAction();
  // DM-7283: reports against a user resolve through their own route.
  const userReportResolution = useResolveUserReports();

  return (
    <Moderation
      onModerationAction={input => action.mutate(input)}
      isActionPending={action.isPending}
      onUserReportResolution={input => userReportResolution.mutate(input)}
      isUserReportResolutionPending={userReportResolution.isPending}
    />
  );
}
